'use client'

import { useRef, useEffect, useState } from 'react'
import { Box } from '@mui/material'
import * as maptilersdk from '@maptiler/sdk'
import '@maptiler/sdk/dist/maptiler-sdk.css'

// Types
import type { Map } from '@maptiler/sdk'
import type { MapProps } from '@/types/components/molecules/map'

// Utils

const MapMolecule = (props: MapProps) => {
	// Props
	const { mapKey, markers } = props

	// Variables
	maptilersdk.config.apiKey = mapKey
	const mapContainer = useRef<HTMLDivElement | null>(null)
	const map = useRef<Map | null>(null)
	const [zoom] = useState<number>(6.5)
	const center = { lat: 63.34088346599603, lng: -116.136474609375 }

	useEffect(() => {
		if (mapContainer.current) {
			// stops map from intializing more than once
			if (map.current) return

			map.current = new maptilersdk.Map({
				container: mapContainer.current,
				style: maptilersdk.MapStyle.HYBRID,
				center: [center.lng, center.lat],
				zoom: zoom
			})

			if (markers.length)
				markers.map(marker => {
					const popup = new maptilersdk.Popup({ offset: 25 }).setHTML(
						`${marker.image && `<p><img src="${`/api/download${marker.image}`}" alt="${marker.title}" style="width: 100 %; height: auto; margin: 10px 0; " /></p>`}${marker.title && `<h3>${marker.title}</h3>`}${marker.link && `<a href="${marker.link} " target="_blank" rel="noopener noreferrer">View More</a>`}`
					)

					new maptilersdk.Marker({ color: '#0267fe' })
						.setLngLat([marker.lng, marker.lat])
						.setPopup(popup)
						.addTo(map.current as Map)
				})
		}
	}, [center.lng, center.lat, zoom, markers])

	return (
		<Box
			width={1}
			height={{ xs: 'calc(80dvh - 48px - 40px)', sm: 'calc(80dvh - 64px - 40px)', lg: 'calc(80dvh - 80px - 40px)', xl: 'calc(80dvh - 100px - 40px)' }}
			position="relative"
			overflow="hidden"
			sx={{
				'& .container': {
					width: 1,
					height: '80vh',
					position: 'relative'
				},
				'& .map': {
					width: 1,
					height: 1,
					position: 'absolute',
					top: 0,
					left: 0
				}
			}}
		>
			<div className="container">
				<div ref={mapContainer} className="map" />
			</div>
		</Box>
	)
}

export default MapMolecule
